export class StorefrontPolicyModel {
  reg?: string;
  acl?: string;
  dt?: string;
  sp?: Array<string>;
  itvod?: boolean;
  pf?: string;
  pl?: string;
}
